import { NoiseMeter as NoiseMeterIcon } from "assets/icons";
import {
  DropdownSetting,
  InformationSetting,
  RememberSettings,
  ToggleSetting,
} from "components/settings";
import { WidgetNames } from "constants/widgets";
import { WidgetType } from "types/Widget";
import { getSoundsArray } from "util/getSoundsArray";

import { MicPermissionSetting } from "./MicPermissionSetting";
import { MicPickerSetting } from "./MicPickerSetting";
import { NoiseLevelSetting } from "./NoiseLevelSetting";
import { NoiseMeter, NoiseMeterState } from "./NoiseMeter";

export const InteractiveNoiseMeterWidget: WidgetType<NoiseMeterState> = {
  name: "Noise Meter",
  component: NoiseMeter,
  icon: NoiseMeterIcon,
  showOnToolbar: true,
  sizing: {
    minWidth: 95,
    minHeight: 135,
    minAspectRatio: 0.7,
    maxAspectRatio: 0.7,
  },
  defaultState: {
    muted: false,
  },
  defaultSize: {
    aspectRatio: 2,
    widthPercentage: 20,
  },
  settings: {
    headerInfo: {
      editor: InformationSetting,
      info: {
        info: "Visualize and monitor classroom noise levels.<br /><br />Configure which microphone to use and when to play a sound.",
      },
    },
    permission: {
      editor: MicPermissionSetting,
      info: {},
    },
    mic: {
      editor: MicPickerSetting,
      info: {},
      defaultValue: "default",
    },
    noise: {
      editor: NoiseLevelSetting,
      info: {},
      defaultValue: "0.5",
    },
    sound: {
      editor: ToggleSetting,
      info: {
        label: "Sound Effects",
      },
      defaultValue: true,
    },
    selectSound: {
      editor: DropdownSetting,
      info: {
        name: "Select Sound",
        options: getSoundsArray(),
      },
      defaultValue: "yoo-hoo.mp3",
    },
    rememberSettings: {
      editor: RememberSettings,
      info: {
        widgetName: WidgetNames.noiseMeter,
        widgetDisplayName: "Noise Meter",
      },
    },
  },
  quickActions: {},
};
